import { ApiBaseFront } from "../../front/api-base-front";

type Params = {
  kijshopCd: string,
  folderId: string,
};

export class ApiPrintFavoriteFolderDelete extends ApiBaseFront<{}> {
  constructor(param: Params) {
    const {
      kijshopCd,
      folderId,
    } = param;

    super(
      'DELETE',
      `/api/v1/print/shop/${kijshopCd}/favfolder/${folderId}`,
      'JSON',
      {},
    );
  }
}
